import { Alert, Button, Dialog, Snackbar } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useAuth from '../../../components/hooks/useAuth'
import { useTheme } from '../../../components/hooks/useTheme'
import useDelete from '../../../components/hooks/useDelete';
import { disableVehicleLocationStatusColorCode } from '../../../utils/statusColorCode';
import colorConfigs from '../../../configs/colorConfigs';
import Cookies from 'js-cookie';
import { delete_DisabledVehicleLocation } from '../../../services/DisabledVehicleLocation';
import { Link, useNavigate } from 'react-router-dom';
import baseURL from '../../../configs/api';
import { CustomImagePopup } from '../../../components/common/CustomImagePopup';
import useTenant from '../../../components/hooks/useTenant';

type DisabledVehicleLocationRequestDetailsProps = {
    open: boolean;
    onClose: () => void;
    setPleaseWait: (value: boolean) => void;
    isCompletedOrCancelled: boolean;
    disableVehicleLocationDetails: any;
    refreshTheShareLocationRequest: () => void;
}

const DisabledVehicleLocationRequestDetails = ({
    open,
    onClose,
    setPleaseWait,
    isCompletedOrCancelled,
    disableVehicleLocationDetails,
    refreshTheShareLocationRequest
}: DisabledVehicleLocationRequestDetailsProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { theme, themeStyles } = useTheme();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [showCopyPopup, setShowCopyPopup] = useState<boolean>(false);
    const [imagePopup, setImagePopup] = useState<boolean>(false);

    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    const [statusColor, setStatusColor] = useState<any | null>({
        colorBg: "#000000",
        colorText: "#000000"
    });

    useEffect(() => {
        if (disableVehicleLocationDetails) {
            let colorObj = disableVehicleLocationStatusColorCode?.find((color: any) => color?.label === disableVehicleLocationDetails?.status?.trim()?.toLowerCase())
                || {
                colorBg: "#000000",
                colorText: "#000000"
            };

            setStatusColor(colorObj);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disableVehicleLocationDetails])

    const deleteThePaymenRequest = () => {
        if (!isCompletedOrCancelled) {
            setDeleteData({
                id: disableVehicleLocationDetails?.id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this Share Location Request?`,
                isDelete: async (callback: any) => {
                    callback();

                    setPleaseWait(true);

                    await delete_DisabledVehicleLocation(disableVehicleLocationDetails?.id, auth?.id, tenantId)
                        .then(() => {
                            onClose();
                            refreshTheShareLocationRequest();
                            setPleaseWait(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWait(false);
                            handleTenantError(error);
                        });
                }
            });

            setDeletePopup(true);
        }
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '600px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => onClose()}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Share Location Request</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <div className="flex flex-col gap-y-[0.5rem]">
                                                <div>
                                                    <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Name</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                                                                {
                                                                    disableVehicleLocationDetails?.vehicleName
                                                                        ? (
                                                                            <span
                                                                                className="text-blue-500 cursor-pointer underline"
                                                                                onClick={() =>
                                                                                    navigate("/fleet/vehicle/editvehicles", {
                                                                                        state: disableVehicleLocationDetails?.vehicleId,
                                                                                    })
                                                                                }
                                                                            >
                                                                                {disableVehicleLocationDetails?.vehicleName}
                                                                            </span>
                                                                        ) : (
                                                                            <>
                                                                                --
                                                                            </>
                                                                        )
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Status</label>
                                                            <span className={`w-fit text-xs font-medium px-[10px] py-[2px] rounded-xl border ${themeStyles.main.borderColor} ${statusColor?.colorText} ${statusColor?.colorBg}`}>
                                                                {disableVehicleLocationDetails?.status || "--"}
                                                            </span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Email</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{disableVehicleLocationDetails?.email || "--"}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{disableVehicleLocationDetails?.phoneNumber || "--"}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Location</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{disableVehicleLocationDetails?.location || "--"}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>LatLng</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>
                                                                {
                                                                    (disableVehicleLocationDetails?.latitude && disableVehicleLocationDetails?.longitude)
                                                                        ? (
                                                                            <span className="flex gap-x-[0.25rem] items-center">
                                                                                <Link
                                                                                    to={`https://www.google.com/maps/place/${disableVehicleLocationDetails?.latitude},${disableVehicleLocationDetails?.longitude}`}
                                                                                    className="text-blue-500 cursor-pointer underline"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {disableVehicleLocationDetails?.latitude}, {disableVehicleLocationDetails?.longitude}
                                                                                </Link>

                                                                                <button
                                                                                    onClick={() => {
                                                                                        if (showCopyPopup) {
                                                                                            setShowCopyPopup(false);
                                                                                        }
                                                                                        const latLng = `${disableVehicleLocationDetails.latitude}, ${disableVehicleLocationDetails.longitude}`;
                                                                                        navigator.clipboard.writeText(latLng);
                                                                                        setShowCopyPopup(true);
                                                                                        setTimeout(() => {
                                                                                            setShowCopyPopup(false);
                                                                                        }, 500);
                                                                                    }}
                                                                                    title="Copy LatLng"
                                                                                    type="button"
                                                                                    className="ml-[6px] bg-none border-none cursor-pointer my-auto"
                                                                                >
                                                                                    <span className={`material-symbols-outlined text-[1rem]`}>
                                                                                        content_copy
                                                                                    </span>
                                                                                </button>
                                                                            </span>
                                                                        ) : (
                                                                            <>
                                                                                --
                                                                            </>
                                                                        )
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Comment</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{disableVehicleLocationDetails?.comment || "--"}</span>
                                                        </div>

                                                        <div className="flex flex-col gap-y-[0.125rem]">
                                                            <label className={`text-xs font-bold ${themeStyles.form.tailwindLabelTextColor}`}>Is Responded</label>
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{disableVehicleLocationDetails?.isResponded ? "Yes" : "No"}</span>
                                                        </div>


                                                        <div className="col-span-2 flex flex-col gap-y-[0.25rem]">
                                                            <label className={`text-xs font-bold  ${themeStyles.form.tailwindLabelTextColor}`}>Image</label>
                                                            {
                                                                disableVehicleLocationDetails?.locationImage
                                                                    ? (
                                                                        <>
                                                                            <img
                                                                                src={`${baseURL}reservationFile/Get?name=${disableVehicleLocationDetails?.locationImage}`}
                                                                                alt="location"
                                                                                className="w-full h-[380px] cursor-pointer"
                                                                                onClick={() => setImagePopup(true)}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{"No Image"}</span>
                                                                    )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-4 mt-6">
                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={onClose}
                                                >
                                                    Cancel
                                                </Button>

                                                <Button
                                                    type="button"
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.delete.bg
                                                    }}
                                                    onClick={deleteThePaymenRequest}
                                                    disabled={isCompletedOrCancelled}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={showCopyPopup}
                autoHideDuration={1000}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    LatLng is copied
                </Alert>
            </Snackbar>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={`${baseURL}reservationFile/Get?name=${disableVehicleLocationDetails?.locationImage}`}
                imageBaseUrlPath="location"
            />
        </>
    )
}

export default DisabledVehicleLocationRequestDetails